import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './ContactPage.css';

const ContactPage = () => {
  const contactInfo = [
    {
      icon: 'fas fa-map-marker-alt',
      title: 'Visit Us',
      details: ['NLNG Residential Area', 'Finima, Rivers State', 'Nigeria'],
      color: '#27a85a'
    },
    {
      icon: 'fas fa-phone-alt',
      title: 'Call Us',
      details: ['+234 703 636 6115'],
      actions: ['Call Now', 'WhatsApp'],
      color: '#27a85a'
    },
    {
      icon: 'fas fa-envelope',
      title: 'Email Us',
      details: ['info@nlngraclub.com', 'membership@nlngraclub.com'],
      actions: ['Send Email'],
      color: '#27a85a'
    },
    {
      icon: 'fas fa-clock',
      title: 'Office Hours',
      details: ['Mon-Fri: 8:00 AM - 8:00 PM', 'Sat: 9:00 AM - 6:00 PM', 'Sun: 10:00 AM - 4:00 PM'],
      color: '#27a85a'
    }
  ];

  const departments = [
    { name: 'Membership', email: 'membership@nlngraclub.com', phone: '+234 703 636 6115', icon: 'fas fa-id-card' },
    { name: 'Events & Booking', email: 'events@nlngraclub.com', phone: '+234 703 636 6115', icon: 'fas fa-calendar-alt' },
    { name: 'Facilities', email: 'facilities@nlngraclub.com', phone: '+234 703 636 6115', icon: 'fas fa-building' },
    { name: 'Sports Sections', email: 'sports@nlngraclub.com', phone: '+234 703 636 6115', icon: 'fas fa-futbol' }
  ];

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="contact-hero-bg"></div>
        <div className="container">
          <motion.div
            className="contact-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="contact-hero-badge">Get in Touch</span>
            <h1 className="contact-hero-title">Contact <span className="text-gradient">Us</span></h1>
            <p className="contact-hero-subtitle">
              We're here to help and answer any questions you might have
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="contact-info-section">
        <div className="container">
          <div className="contact-cards-grid">
            {contactInfo.map((info, index) => (
              <motion.div
                key={index}
                className="contact-info-card"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -8 }}
              >
                <div className="contact-info-icon">
                  <i className={info.icon} style={{ color: info.color }}></i>
                </div>
                <h3>{info.title}</h3>
                {info.details.map((detail, i) => (
                  <p key={i}>{detail}</p>
                ))}
                {info.actions && (
                  <div className="contact-info-actions">
                    {info.actions.map((action, i) => (
                      <button key={i} className="contact-info-btn">
                        {action} <i className="fas fa-arrow-right"></i>
                      </button>
                    ))}
                  </div>
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </section>

{/* Map Section - Full Width */}
{/* Map Section - Full Width */}
<section className="contact-form-section full-width-map">
  <div className="contact-map-full">
    <div className="contact-map-card-full">
      <div className="contact-map-container-full">
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d63644.03328441496!2d7.1900359289026525!3d4.457142952342746!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x106850dae227e747%3A0xfdab92c24461a203!2sBonny%20Island!5e0!3m2!1sen!2sng!4v1775114076048!5m2!1sen!2sng" 
          width="100%" 
          height="400" 
          style={{ border: 0 }} 
          allowFullScreen="" 
          loading="lazy" 
          referrerPolicy="no-referrer-when-downgrade"
          title="Club Location"
        ></iframe>
      </div>
      <div className="contact-map-details-full">
        <p><i className="fas fa-map-pin"></i> NLNG Residential Area, Finima, Rivers State, Nigeria</p>
        <a href="#" className="contact-directions-btn">
          Get Directions <i className="fas fa-external-link-alt"></i>
        </a>
      </div>
    </div>
  </div>
</section>

      {/* Departments Section */}
      <section className="contact-departments">
        <div className="container">
          <div className="departments-header">
            <span className="departments-badge">Direct Contacts</span>
            <h2>Connect with our <span className="text-gradient">Departments</span></h2>
            <p>Reach out directly to the team that can best assist you</p>
          </div>
          
          <div className="departments-grid">
            {departments.map((dept, index) => (
              <motion.div
                key={index}
                className="department-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -5 }}
              >
                <div className="department-icon">
                  <i className={dept.icon}></i>
                </div>
                <h3>{dept.name}</h3>
                <div className="department-contact">
                  <p><i className="fas fa-envelope"></i> {dept.email}</p>
                  <p><i className="fas fa-phone-alt"></i> {dept.phone}</p>
                </div>
                <button className="department-btn">Contact Department →</button>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="contact-faq">
        <div className="container">
          <div className="faq-wrapper">
            <div className="faq-header">
              <h2>Frequently Asked <span className="text-gradient">Questions</span></h2>
              <p>Find quick answers to common questions</p>
            </div>
            <div className="faq-grid">
              <div className="faq-item">
                <i className="fas fa-clock"></i>
                <div>
                  <h4>What are your operating hours?</h4>
                  <p>We're open Monday-Friday 8am-8pm, Saturday 9am-6pm, and Sunday 10am-4pm.</p>
                </div>
              </div>
              <div className="faq-item">
                <i className="fas fa-handshake"></i>
                <div>
                  <h4>How do I become a member?</h4>
                  <p>Visit our membership page or contact our membership department for assistance.</p>
                </div>
              </div>
              <div className="faq-item">
                <i className="fas fa-calendar-check"></i>
                <div>
                  <h4>How can I book facilities?</h4>
                  <p>Use our online booking system or call our facilities department to reserve.</p>
                </div>
              </div>
              <div className="faq-item">
                <i className="fas fa-ticket-alt"></i>
                <div>
                  <h4>Can I host events at the club?</h4>
                  <p>Yes! Contact our events team to discuss your event needs and availability.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;